import 'css-chunksrc/client/common/layout/zonesList/zone/projectsList/project/styles.scss';export default {
  "project": "_project_7dd8i_1",
  "main": "_main_7dd8i_17",
  "name": "_name_7dd8i_29",
  "tasks": "_tasks_7dd8i_38",
  "icon": "_icon_7dd8i_42",
  "listsList": "_listsList_7dd8i_49",
  "selected": "_selected_7dd8i_53",
  "loader": "_loader_7dd8i_67"
};